import React from 'react';
import { fmtLatency } from '../lib/duration';

// Format delta with the same precision the parent MetricCard uses for the
// matching suffix — `ms` values render as integers, others get one decimal.
// The 'latency' suffix returns a unit-included string (e.g., "1.2s") so the
// renderers below skip the trailing suffix concatenation.
function formatDelta(delta, suffix) {
  if (suffix === 'latency') {
    const sign = delta < 0 ? '-' : '';
    return `${sign}${fmtLatency(Math.abs(delta))}`;
  }
  if (suffix === 'ms') return Math.round(delta).toString();
  return delta.toFixed(1);
}

export default function TrendArrow({ current, previous, tolerance = 1, suffix = '' }) {
  if (current == null || previous == null) {
    return <span className="text-gray-400 text-xs">—</span>;
  }
  const delta = Number(current) - Number(previous);
  const flat = Math.abs(delta) <= tolerance;
  const formatted = formatDelta(delta, suffix);
  const renderedSuffix = suffix === 'latency' ? '' : suffix;
  if (flat) {
    const sign = delta > 0 ? '+' : (delta < 0 ? '' : '±');
    return (
      <span className="text-gray-400 text-xs" title={`Δ ${formatted}${renderedSuffix}`}>
        → {sign}{formatted}{renderedSuffix}
      </span>
    );
  }
  if (delta > 0) {
    return (
      <span className="text-emerald-600 dark:text-emerald-400 text-xs font-medium" title={`+${formatted}${renderedSuffix}`}>
        ↑ +{formatted}{renderedSuffix}
      </span>
    );
  }
  return (
    <span className="text-red-600 dark:text-red-400 text-xs font-medium" title={`${formatted}${renderedSuffix}`}>
      ↓ {formatted}{renderedSuffix}
    </span>
  );
}
